import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { cn } from '../../utils/cn';
interface AccordionItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
export function AccordionItem({
  question,
  answer,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border-b border-gray-800 last:border-0" data-id="element-7">
      <button className="flex w-full items-center justify-between py-5 text-left focus:outline-none group" onClick={onClick} aria-expanded={isOpen} data-id="element-8">
        <span className="font-heading text-lg md:text-xl font-semibold text-white group-hover:text-patriot-red transition-colors" data-id="element-9">
          {question}
        </span>
        <ChevronDownIcon className={cn('h-5 w-5 text-patriot-red transition-transform duration-300', isOpen ? 'rotate-180' : '')} data-id="element-10" />
      </button>
      <div className={cn('overflow-hidden transition-all duration-300 ease-in-out', isOpen ? 'max-h-96 opacity-100 pb-5' : 'max-h-0 opacity-0')} data-id="element-11">
        <p className="text-gray-400 leading-relaxed" data-id="element-12">{answer}</p>
      </div>
    </div>;
}